import React, { useState, useEffect } from "react";
import { Input, Checkbox, Row, Col, Spin } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import jsPDF from "jspdf";
import { useLocation, useHistory } from "react-router-dom";
import { getImage } from "../../../../utilities/storageOperations/downloadURL";
import { LoadingOutlined, SearchOutlined } from "@ant-design/icons";
import PDFMerger from "pdf-merger-js/browser";
import "./PdfMaker.css";
import {useSelector } from "react-redux";
import threeDicon from "../../../../assets/img/chat-icon.png";
import { Link } from 'react-router-dom'
// assets/img/3d_icon.svg";

export default function PdfMaker(props) {
  const [selectAll, setSelectAll] = useState(false);
  const [credentials, setCredentials] = useState(null);
  const [filteredCredential, setFilteredCredentials] = useState([]);
  const [credSearch, setCredSearch] = useState(null);
  const [disable, setdisable] = useState(true);
  const [credentialsName, setCredentialsNames] = useState([]);
  const [filteredNames, setFilteredNames] = useState([]);
  // const [displayArray, setDisplayArray] = useState([]);
  const [generatePDFLoading,setGeneratePdfLoading] = useState(false);

  let array = [];

  const [filteredArray, setFilteredArray] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const userSKillListing = useSelector(
    (state) => state.oneUserskillListingReducer.skillListings
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const unique = Array.from(new Set(props.data.map(obj => obj?.CredentialDocument?.CredentialDocumentId)))
      .map(id => props.data.reverse().find(obj => obj?.CredentialDocument?.CredentialDocumentId === id));
    
    let temp = unique.map((el) => ({ ...el, isSelected: false }));
    setCredentials(temp.filter((item) => {
      if(item?.CredentialDocument?.CredentialDocumentId == undefined || item?.CredentialDocument?.CredentialDocumentId == null){
        return false;
      }
      else if(userSKillListing?.isPlacedBidByTalentOrEmployer == false && item?.CredentialDocument?.CredentialDocumentName == "Resume"){
        return false;
      }
      else{
        return true; 
      }
    }));
    setFilteredCredentials(temp);
    // getImgs();
  }, [props.data]);

  useEffect(() => {
    let arrayData = [];
    if (credentials != null) {
      for (let i = 0; i < credentials.length; i++) {
        arrayData.push(
          credentials[i]?.CredentialDocument?.CredentialDocumentName
        );
      }

      setCredentialsNames(arrayData);
      setFilteredNames(arrayData);
    }
  }, [credentials]);

  const searchHandler = (seacrhText) => {
    // return;
    let filteredData = credentialsName?.filter((i) =>
      i.toLowerCase().includes(seacrhText.toLowerCase())
    );
    setFilteredArray(filteredData);
    setShowSuggestions(true);

    var search = credentials.filter((item) =>
      item?.CredentialDocument?.CredentialDocumentName.toLowerCase().includes(
        seacrhText.toLowerCase()
      )
    );
    if (seacrhText == "") setShowSuggestions(false);
    if (seacrhText === "") {

      const unique = Array.from(new Set(props?.data?.map(obj => obj?.CredentialDocument?.CredentialDocumentId)))
      .map(id => props?.data?.find(obj => obj?.CredentialDocument?.CredentialDocumentId === id));

      setCredentials(unique?.map((el) => ({ ...el, isSelected: false })).filter((item) => {
        if(item?.CredentialDocument?.CredentialDocumentId == undefined || item?.CredentialDocument?.CredentialDocumentId == null){
          return false;
        }
        else if(userSKillListing?.isPlacedBidByTalentOrEmployer == false && item?.CredentialDocument?.CredentialDocumentName == "Resume"){
          return false;
        }
        else{
          return true; 
        }
      }));
    } else {
      setCredentials(search.filter((item) => {
        if(item?.CredentialDocument?.CredentialDocumentId == undefined || item?.CredentialDocument?.CredentialDocumentId == null){
          return false;
        }
        else if(userSKillListing?.isPlacedBidByTalentOrEmployer == false && item?.CredentialDocument?.CredentialDocumentName == "Resume"){
          return false;
        }
        else{
          return true; 
        }
      }));
    }
    setSelectAll(false)
  };

  function getFileExtension(fileName) {
    return fileName?.slice((fileName.lastIndexOf(".") - 1 >>> 0) + 2);
  }

  /// sggestions onclick handler
  const suggestionsHandler = (value) => {
    setShowSuggestions(false);

    var search = credentials.filter((item) =>
      item?.CredentialDocument?.CredentialDocumentName.toLowerCase().includes(
        value.toLowerCase()
      )
    );
    if (value === "") {
      const unique = Array.from(new Set(props?.data?.map(obj => obj?.CredentialDocument?.CredentialDocumentId)))
      .map(id => props?.data?.find(obj => obj?.CredentialDocument?.CredentialDocumentId === id));

      setCredentials(unique?.map((el) => ({ ...el, isSelected: false })).filter((item) => {
        if(item?.CredentialDocument?.CredentialDocumentId == undefined || item?.CredentialDocument?.CredentialDocumentId == null){
          return false;
        }
        else if(userSKillListing?.isPlacedBidByTalentOrEmployer == false && item?.CredentialDocument?.CredentialDocumentName == "Resume"){
          return false;
        }
        else{
          return true; 
        }
      }));
    } else {
      setCredentials(search.filter((item) => {
        if(item?.CredentialDocument?.CredentialDocumentId == undefined || item?.CredentialDocument?.CredentialDocumentId == null){
          return false;
        }
        else if(userSKillListing?.isPlacedBidByTalentOrEmployer == false && item?.CredentialDocument?.CredentialDocumentName == "Resume"){
          return false;
        }
        else{
          return true; 
        }
      }));
    }

    // var search = credentials.filter((item) =>
    // item.credential_documents?.CredentialDocumentName.toLowerCase().includes(value.toLowerCase())
    // );
    // setFilteredCredentials(search);
  };

  const handleCheckAll = (e) => {
    setSelectAll(!selectAll);
    let updated = [...credentials];
    updated = updated.filter((item) => {
      if(item?.CredentialDocument?.CredentialDocumentId == undefined || item?.CredentialDocument?.CredentialDocumentId == null){
        return false;
      }
      else if(userSKillListing?.isPlacedBidByTalentOrEmployer == false && item?.CredentialDocument?.CredentialDocumentName == "Resume"){
        return false;
      }
      else{
        return true; 
      }
    }).map((task) => {
      if (e) {
        return { ...task, isSelected: true };
      } else {
        return { ...task, isSelected: false };
      }
    });
    setCredentials(credentials.map(item=> ({...item,isSelected: e})));
    setFilteredCredentials(updated);
    if (e) {
      setdisable(false);
    } else {
      setdisable(true);
    }
    if(updated.length == 0 ){
      setdisable(true)
    }
  };


  const handleCheck = (label) => {
    let updated = [...credentials];
    let checkedCount = 0;
    updated = updated.map((task) => {
      if (label === task?.CredentialDocument?.CredentialDocumentId) {
        return { ...task, isSelected: !task.isSelected };
      }
      return task;
    });
    
    updated.map((res)=>{
      if(res.isSelected){
        return checkedCount++
      }
      else{
        return checkedCount--
      }
    })

    if(checkedCount !== credentials.length){
      setSelectAll(false)
    }
    else{
      setSelectAll(true)
    }

    setCredentials(updated.filter((item) => {
      if(item?.CredentialDocument?.CredentialDocumentId == undefined || item?.CredentialDocument?.CredentialDocumentId == null){
        return false;
      }
      else if(userSKillListing?.isPlacedBidByTalentOrEmployer == false && item?.CredentialDocument?.CredentialDocumentName == "Resume"){
        return false;
      }
      else{
        return true; 
      }
    }))
    const filterCredentials = updated.filter((item) => {
      if(item?.CredentialDocument?.CredentialDocumentId == undefined || item?.CredentialDocument?.CredentialDocumentId == null){
        return false;
      }
      else if(userSKillListing?.isPlacedBidByTalentOrEmployer == false && item?.CredentialDocument?.CredentialDocumentName == "Resume"){
        return false;
      }
      else{
        return true; 
      }
    });
    setFilteredCredentials(filterCredentials);
    // if(disable){
    setdisable(!disable);
    // }
    filterCredentials.forEach((item) => {
      if (item.isSelected) {
        setdisable(false);
        return;
      }
    });
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(credentials);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setCredentials(items.filter((item) => {
      if(item?.CredentialDocument?.CredentialDocumentId == undefined || item?.CredentialDocument?.CredentialDocumentId == null){
        return false;
      }
      else if(userSKillListing?.isPlacedBidByTalentOrEmployer == false && item?.CredentialDocument?.CredentialDocumentName == "Resume"){
        return false;
      }
      else{
        return true; 
      }
    }));
  };

  const A4_PAPER_DIMENSIONS = {
    width: 210,
    height: 297,
  };
  const A4_PAPER_RATIO = A4_PAPER_DIMENSIONS.width / A4_PAPER_DIMENSIONS.height;

  // Calculates the best possible position of an image on the A4 paper format,
  // so that the maximal area of A4 is used and the image ratio is preserved.
  const imageDimensionsOnA4 = (dimensions) => {
    const isLandscapeImage = dimensions.width >= dimensions.height;

    // If the image is in landscape, the full width of A4 is used.
    if (isLandscapeImage) {
      return {
        width: A4_PAPER_DIMENSIONS.width,
        height:
          A4_PAPER_DIMENSIONS.width / (dimensions.width / dimensions.height),
      };
    }

    // If the image is in portrait and the full height of A4 would skew
    // the image ratio, we scale the image dimensions.
    const imageRatio = dimensions.width / dimensions.height;
    if (imageRatio > A4_PAPER_RATIO) {
      const imageScaleFactor =
        (A4_PAPER_RATIO * dimensions.height) / dimensions.width;

      const scaledImageHeight = A4_PAPER_DIMENSIONS.height * imageScaleFactor;

      return {
        height: scaledImageHeight,
        width: scaledImageHeight * imageRatio,
      };
    }

    // The full height of A4 can be used without skewing the image ratio.
    return {
      width:
        A4_PAPER_DIMENSIONS.height / (dimensions.height / dimensions.width),
      height: A4_PAPER_DIMENSIONS.height,
    };
  };
  const downloadFile = (blob, name) => {
    setGeneratePdfLoading(false);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  };
  const convertImageToPdf = async (link) => {
    try {
      const doc = new jsPDF();
      const imageDimensions = imageDimensionsOnA4({
        width: 200,
        height: 200,
      });
      doc.deletePage(1);
      doc.addPage();
      doc.addImage(
        link,
        "png",
        (A4_PAPER_DIMENSIONS.width - imageDimensions.width) / 2,
        (A4_PAPER_DIMENSIONS.height - imageDimensions.height) / 2,
        imageDimensions.width,
        imageDimensions.height
      );

      return doc.output("blob");
    } catch (error) {
      console.warn(error);
      props.setError(true);
    }
  };
  const makeBlob = async (link) => {
    try {
      const response = await fetch(link);
      const blob = await response.blob();
      return blob;
    } catch (error) {
      console.warn(error);
      props.setError(true);
    }
  };
  const handleGeneratePdfFromImages = async () => {
    try {
      props.setImagesGenerated(true);
      let images = [];
      setGeneratePdfLoading(true);
      images = credentials
        .filter((item) => item.isSelected)
        .map(async (item, index) => {
          if (
            item.isSelected &&
            (getFileExtension(item?.FileName) == "doc" ||
              getFileExtension(item?.FileName) == "docx")
          ) {
            props.setError(true);
          } else if (item.isSelected) {
            // return await getImage(item.DocumentUrl);
            return `${process.env.REACT_APP_S3_URL}${
              item.DocumentUrl?.charAt(0) !== "/" ? "/" : ""
            }${item.DocumentUrl}`;
          }
        });
      images = await Promise.all(images);
      let pdfBlob = [];
      images.forEach((image, index) => {
        // if(getFileExtension(image) == 'doc' || getFileExtension(image) == 'docx') {
        //   props.setError(true);
        // }
        if (typeof image !== "undefined") {
          let imgSrc = image.split("?");
          image = imgSrc[0];
          if (image.includes("pdf")) {
            pdfBlob.push(makeBlob(image));
          } else {
            pdfBlob.push(convertImageToPdf(image));
          }
        }
      });
      const pdfs = await Promise.all(pdfBlob);
      const merger = new PDFMerger();
      for (const [index, file] of pdfs.entries()) {
        await merger.add(file).catch((e) => {
          window.open(`${images[index]}`);
          console.log("Error adding file", e);
        });
      }
      const mergedPdf = await merger.saveAsBlob();
      downloadFile(mergedPdf, "credentials");
      props.setImagesGenerated(true);
      setTimeout(() => props.setImagesGenerated(false), 2000);
    } catch (error) {
      console.warn("error : ", error);
      props.setError(true);
    } finally {
      setGeneratePdfLoading(false);
    }
  };

  const openDocument=(event,key)=>{
    window.open(`${process.env.REACT_APP_S3_URL}${key.charAt(0) !== "/" ? "/" : ""}${key}`)
    event.stopPropagation()
  }
  return (
    <>
      <div className="pdf-maker">
        <Input
          className="resume-3d-inp"
          type="input"
          allowClear
          placeholder="Find document(s) or Find material(s)"
          prefix={<SearchOutlined className="resume-3d-searchicon" />}
          // style={{ marginTop: '2px' }}
          onChange={(e) => searchHandler(e.target.value)}
        />

        {showSuggestions && (
          <div className="suggestion-view">
            {filteredArray?.map((i, index) => (
              <div
                key={index}
                onClick={() => suggestionsHandler(i)} //suggestionsHandler()
                className="suggestionItem"
              >
                {i}
              </div>
            ))}
          </div>
        )}

        <Row className="selectAllContainer">
          <div className="selectAllTitle">
            {selectAll ? "Deselect all documents" : "Select all documents"}
          </div>
          <Checkbox
            checked={selectAll}
            onChange={(e) => handleCheckAll(e.target.checked)}
            className="resume-3d-checkbox"
            // style = {{...styles.CheckBox, marginLeft:width(2)}}
          />
        </Row>

        <div
          className={windowDimensions.width > 991 ? "dragDropContainer" : ""}
          style={{
            overflow: "auto",
          }}
        >
          {/* minHeight: "420px" */}

          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="characters">
              {(provided) => (
                <Row {...provided.droppableProps} ref={provided.innerRef}>
                  {credentials
                    ? credentials.filter((item) => {
                      if( item?.CredentialDocument?.CredentialDocumentId == undefined || item?.CredentialDocument?.CredentialDocumentId == null){
                        return false;
                      }
                      else if(userSKillListing?.isPlacedBidByTalentOrEmployer == false && item?.CredentialDocument?.CredentialDocumentName == "Resume"){
                        return false;
                      }
                      else{
                        return true; 
                      }
                    }).map((item, index) => {
                        return (
                          <Draggable
                            key={`${index}`}
                            draggableId={`${index}`}
                            index={index}
                          >
                            {(provided) => (
                              <Row
                                className="credentialContainer"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                {getFileExtension(item?.FileName) === "docx" ? (
                                  <div className='document-name'
                                  onClick={() => window.open(`${process.env.REACT_APP_S3_URL}${item?.DocumentUrl?.charAt(0) !== "/" ? "/" : ""}${item?.DocumentUrl}`) }
                                >
                                  {
                                    item?.CredentialDocument
                                      ?.CredentialDocumentName
                                  }
                                </div>)
                                : (
                                <>
                                <Link to={{
                                  pathname:'/filecontainer',
                                  search: item.DocumentUrl
                                  }} target="_blank">
                                  <div className='document-name'
                                    // onClick={(event) => openDocument(event, item.DocumentUrl)}
                                  >
                                    {
                                      item?.CredentialDocument
                                        ?.CredentialDocumentName
                                    }
                                  </div>
                                </Link>
                                </>)
                                 }
                                <Checkbox
                                  checked={item.isSelected}
                                  onChange={() => handleCheck(item?.CredentialDocument?.CredentialDocumentId)}
                                  className="resume-3d-checkbox"
                                />
                              </Row>
                            )}
                          </Draggable>
                        );
                      })
                    : null}
                </Row>
              )}
            </Droppable>
          </DragDropContext>
        </div>
        {location.state?.fromChat == true ? 
      <Row className="generate-btn-container-chat">
        <Col xs={24} sm={24} md={10} lg={10} xl={10}>
        <button
          className="hired-3d-pdf"
          onClick={() => history.push({
            pathname: '/conversations', 
            state:{
              openConvo: true,
              conversationId: props.conversationId}
            })
        }
        >
          Move to hired
        </button>
        </Col>
        <Col xs={24} sm={24} md={10} lg={10} xl={10}>
        <button
            className={`resume-3d-pdf-chat ${
              disable ? "resume-btn-grey-chat" : "resume-btn-color-chat"
            }`}
            onClick={() => {
              if (!disable) {
                if (filteredCredential.filter((item) => item.isSelected).length == 1 && (filteredCredential.filter((item) => item.isSelected && (getFileExtension(item?.FileName) == 'doc' || getFileExtension(item?.FileName) == 'docx' ))).length != 0 ) {
                  return window.open(`${process.env.REACT_APP_S3_URL}${filteredCredential?.[0]?.DocumentUrl?.charAt(0) !== "/" ? "/" : ""}${filteredCredential?.[0]?.DocumentUrl}`); 
                } else {
                  handleGeneratePdfFromImages();
                }
              }
            }}
          >
            {generatePDFLoading?<LoadingOutlined/>:"Download PDF"}
          </button>
        </Col>
        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
        <button
          className="hired-3d-pdf-chat"
          onClick={() => history.push({
            pathname: '/conversations', 
            state:{
              openConvo: true,
              conversationId: props.conversationId}
            })
        }
        >
          <img className="chat-Icon" src={threeDicon} />
        </button>
        </Col>
      </Row> : 
    <Row className="generate-btn-container">
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <button
            className={`resume-3d-pdf ${
              disable ? "resume-btn-grey" : "resume-btn-color"
            }`}
            onClick={() => {
              if (!disable) {
                if (credentials.filter((item) => item.isSelected).length == 1 && (credentials.filter((item) => item.isSelected && (getFileExtension(item?.FileName) == 'doc' || getFileExtension(item?.FileName) == 'docx' ))).length != 0 ) {
                  return window.open(`${process.env.REACT_APP_S3_URL}${credentials?.[0]?.DocumentUrl?.charAt(0) !== "/" ? "/" : ""}${credentials?.[0]?.DocumentUrl}`); 
                } else {
                  handleGeneratePdfFromImages();
                }
              }
            }}
          >
            {generatePDFLoading?<LoadingOutlined/>:"Download PDF"}
          </button>
        </Col>
      </Row>
      }
      </div>
    </>
  );
}
